import e from "./_baseIsTypedArray.js";
import y from "./_baseUnary.js";
import r from "./_nodeUtil.js";
var a = r && r.isTypedArray, o = a ? y(a) : e;
const i = o;
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isTypedArray.js
// module id = 472
// module chunks = 67